import React from 'react';
import { Card, Icon, P, IconProps } from '@fashionnovateam/nova-ui-toolkit';

type FormSectionProps = {
  icon: IconProps['name'];
  title: string;
  gradientFrom: string;
  gradientTo: string;
  bgColor: string;
  children: React.ReactNode;
};

export function FormSection({
  icon,
  title,
  gradientFrom,
  gradientTo,
  bgColor,
  children,
}: FormSectionProps) {
  return (
    <Card className="overflow-hidden border border-neutral-200 w-full shadow-sm">
      <div
        className={`w-full px-5 py-3 flex items-center gap-3 bg-gradient-to-r ${gradientFrom} ${gradientTo}`}
      >
        <Icon name={icon} className="text-base-primary" size="20" />
        <P size="md" weight="medium" className="text-base-primary">
          {title}
        </P>
      </div>
      <Card.Body className={`p-5 space-y-4 ${bgColor}`}>{children}</Card.Body>
    </Card>
  );
}
